var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"step"},[_c('el-steps',{attrs:{"active":_vm.active,"align-center":true}},_vm._l((_vm.stepList),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.name},nativeOn:{"click":function($event){return _vm.handleStep(item, index)}}})}),1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }